import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {CarCriteriaComponent} from '../car-criteria/car-criteria.component';
import {
  ConfigService,
  DataShareService,
  DestinationType, SurfCalendarStartDateService,
  SurfCityPipe,
  SurfCriteriaUtil,
  SurfStaticDataService,
  SurfTextCasePipe, SurfTravellerEarliestDepartureDateService
} from '@surf/surf-components-core';
import {ConfigLoader, DataStore} from '@tc-core/util/framework';
import {DataServiceHandler} from '@tc-core/service/service-handlers';

@Component({
  selector: 'surf-car-criteria-dp',
  templateUrl: './car-criteria-dp.component.html'
})
export class CarCriteriaDpComponent extends CarCriteriaComponent implements OnInit {


  @Input() selectComp = false;   /*needed for dp criteria*/
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter<any>();

  isSelected = false;
  msg = '';

  constructor(protected commonService: DataShareService,
              protected dataStore: DataStore,
              protected configLoader: ConfigLoader,
              protected dataServiceHandler: DataServiceHandler,
              public surfCriteriaUtil: SurfCriteriaUtil,
              protected configService: ConfigService,
              protected surfStaticDataService: SurfStaticDataService,
              protected travellerEarliestDepartureDateService: SurfTravellerEarliestDepartureDateService,
              protected surfCalendarStartDateService: SurfCalendarStartDateService) {
    super(commonService, dataStore, configLoader, dataServiceHandler, configService, surfCriteriaUtil, surfCalendarStartDateService,
      surfStaticDataService , travellerEarliestDepartureDateService);
    this.cityPipe = new SurfCityPipe(surfStaticDataService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.ngOnChanges');
    super.ngOnChanges(changes);

    /*if this component is added to the dp criteria panel initially, then it should be selected = true*/
    if (changes.selectComp) {
      this.isSelected = changes.selectComp.currentValue;
    }
  }

  ngOnInit() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.ngOnInit');
    super.ngOnInit();
    this.showTypeAheadContent = true;
    this.showDropOffRecommendations = true;
  }

  public selectComponent() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.selectComponent');
    this.isSelected = true;
  }

  public deselectComponent() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.deselectComponent');
    this.isSelected = false;
    this.showTypeAheadContent = false;
    if (this.selectCarWithOutEnter) {
      this.selectCarWithOutEnter = false;
    } else {
      this.showDropOffRecommendations = false;
    }
    // this.showDropOffRecommendations = false;
  }

  removeItem() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.removeItem');
    if (!this.isRefine && !this.isDPSearch) {
      this.commonService.updateComponentCriteria(null, 'CAR');
    }
    this.itemRemoved.emit(this.index);
  }

  moveToDP(position: string) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.moveToDP');
    if (!this.isRefine) {          /*TODO: Implemented for refine*/
      if (!this.isDPSearch) {                     /*Move to DP search panel if only; was in the component flow previously*/
        this.msg = 'DP_Switch~CAR~' + position;
        // this.commonService.changeMessage(msg);
      }
    }
  }

  handleInputFocusOut(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.handleInputFocusOut');
    console.log(event);
    if (event === 'PICKUP') {
      if (this.carCriteria.pickupLocation) {
        this.selectedPickUpPoint.displayText = this.carCriteria.pickupLocationName;
      } else if (this.carCriteria.pickupGrp) {
        this.cityPipe.transform(this.carCriteria.pickupCity).subscribe(res => {
          this.selectedPickUpPoint.displayText = res;
        });
      } else if (this.carCriteria.pickupCity) {
        this.cityPipe.transform(this.carCriteria.pickupCity).subscribe(res => {
          this.selectedPickUpPoint.displayText = res;
        });
      }
    } else if (event === 'DROP') {
      if (this.carCriteria.returnLocation) {
        this.selectedDropOffPoint.displayText = this.carCriteria.returnLocationName;
      } else if (this.carCriteria.returnGrp) {
        this.cityPipe.transform(this.carCriteria.returnCity).subscribe(res => {
          this.selectedDropOffPoint.displayText = res;
        });
      } else if (this.carCriteria.returnCity) {
        this.cityPipe.transform(this.carCriteria.returnCity).subscribe(res => {
          this.selectedDropOffPoint.displayText = res;
        });
      }
    }
  }

  passengerSplitChange(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.passengerSplitChange');
    if (event && event.length === this.paxSplitArray.length) {
      this.isPaxSplitChanged.emit(false);
    } else {
      this.isPaxSplitChanged.emit(true);
    }
  }

  /**
   * enable passenger split dropdown
   */
  enablePaxSplitDropdown() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.enablePaxSplitDropdown');
    this.enablePaxSplit = true;
  }

  getCountry(city): string {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.getCountry');
    let parentName = null;
    if (city.parent && city.parent.length > 0) {
      city.parent.forEach(p => {
        if (p.type == 20) {
          parentName = p.name;
        }
      });
    }
    return parentName;
  }

  addParentToLocationGroup(locationGroup, city) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-car-criteria/src/lib/car-criteria-dp/car-criteria-dp.component.ts.CarCriteriaDpComponent.addParentToLocationGroup');
    let parent = [];
    if(city){
      parent.push({code: city.code, name: city.name, type: city.type});  /*add city*/
    }
    if(city.parent && city.parent[0]){
      parent.push({code: city.parent[0].code, name: city.parent[0].name, type: city.parent[0].type});  /*add country*/
    }
    locationGroup.parent = parent;
    return locationGroup;
  }
}
